module.exports = __webpack_public_path__ + "staticcomp/img/share.2de34ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share.png
// module id = az9f
// module chunks = 39